import { render, staticRenderFns } from "./ExpansionPanelSvg.vue?vue&type=template&id=4aab0677&scoped=true&"
import script from "./ExpansionPanelSvg.vue?vue&type=script&lang=js&"
export * from "./ExpansionPanelSvg.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionPanelSvg.vue?vue&type=style&index=0&id=4aab0677&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab0677",
  null
  
)

export default component.exports